import Close from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import React, { useEffect } from 'react';
import {
  Alert,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
} from '@mui/material';
import Select from '@mui/material/Select';
import tagService from '../../../../services/api/insights/tagService';
import QuestionList from '../../questionBank/components/QuestionList';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import surveyQuestionService from '../../../../services/api/insights/surveyQuestionService';

const { mandy } = colors;

export default function QuestionBankList({
  onClose,
  template,
  updateQuestionList,
}) {
  const [loading, setLoading] = React.useState(false);
  const [tags, setTags] = React.useState([]);
  const [selectedQuestions, setSelectedQuestions] = React.useState([]);
  const [selectedTag, setSelectedTag] = React.useState(null);

  useEffect(() => {
    setLoading(true);
    tagService
      .getTags()
      .then((res) => {
        setTags(res.sort((x, y) => x.name.localeCompare(y.name)));
      })
      .finally(() => setLoading(false));
  }, []);

  const saveQuestions = () => {
    if (template) {
      let sq = [];
      const existingCount = template.surveyQuestions?.length ?? 0;
      selectedQuestions.map((q, idx) => {
        sq.push({
          surveyId: template.id,
          questionId: q.id,
          order: existingCount + idx,
        });
      });
      if (sq.length > 0) {
        surveyQuestionService
          .addSurveyQuestionList(sq)
          .then((res) => {
            updateQuestionList();
            onClose(false);
          })
          .catch((res) => {});
      }
    }
  };

  return (
    <Modal open={true} onClose={(s) => onClose(true)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '80%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',          
          p: 3,
        }}
      >
        <Grid container>
          <Grid item xs={6} lg={6} md={6} sm={6}>
            <h3>Question Bank</h3>
          </Grid>
          <Grid item xs={6} lg={6} md={6} sm={6} textAlign={'right'}>
            <IconButton onClick={(e) => onClose(false)}>
              <Close></Close>
            </IconButton>
          </Grid>
        </Grid>
        <div className='question-bank-container bank-container'>
          <Grid container>
            <Grid item xs={12} lg={8} md={8} sm={12} borderRight='1px solid #e2e2e2'>               
                <FormControl fullWidth className='search-txt'>
                  <InputLabel id='tag-select-label'>Select Tag</InputLabel>
                  <Select
                    fullWidth
                    label='Select Tag'
                    labelId='tag-select-label'
                    value={selectedTag}
                    onChange={(e) => {
                      setSelectedTag(e.target.value);
                    }}
                    id='tag-select'
                    renderValue={(selected) => {
                      const selectedTag = tags.find(
                        (tag) => tag.id === selected.id
                      );
                      return selectedTag ? selectedTag.name : 'Select Tag';
                    }}
                  >
                    {tags.map((tag) => (
                      <MenuItem key={tag.id} value={tag}>
                        {tag.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <QuestionList
                  selectedTag={selectedTag}
                  canNotEdit={true}
                  selectedQuestions={selectedQuestions}
                  setSelectedQuestions={setSelectedQuestions}
                />                
            </Grid>

            <Grid item xs={12} lg={4} md={4} sm={12} p={2}>
              <h3>Selected Questions</h3>
            
              {selectedQuestions.length > 0 ? (
                <>
                  <div className='selected-questions-container'>
                    {selectedQuestions?.map((q) => {
                      return (
                        <div className='selected-questions'>
                          <div>
                            {q.staffText
                              ? q.staffText
                              : q.parentText
                              ? q.parentText
                              : q.pupilText}
                          </div>
                          <div>
                            <IconButton
                              onClick={(c) => {
                                setSelectedQuestions([
                                  ...selectedQuestions.filter(
                                    (x) => x.id !== q.id
                                  ),
                                ]);
                              }}
                            >
                              <RemoveCircleOutline className='icon-delete' />
                            </IconButton>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <AppButton
                    color={mandy}
                    onClick={saveQuestions}
                    style={{ width: '100%', marginTop: '10px' }}
                  >
                    {'Add ' + selectedQuestions?.length + ' Questions'}
                  </AppButton>
                </>
              ) : selectedTag ? (
                <Alert severity='info'>
                  No questions selected.
                </Alert>
              ) : (
                <Alert severity='info'>
                  No questions selected.
                </Alert>
              )}
              
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
}
